<!-- Layout wrapper -->
<div class="layout-wrapper mat-app-background" fxLayout="column" fxFill fxLayoutAlign="none none">
  <!-- toolbar -->
  <app-header *ngIf="!router.url.includes('careers/auth')"></app-header>
  <!-- body  -->
  <!-- given flex auto to fill the page size  -->
  <div class="main-content" fxFlex="auto">
    <!-- Router outlet for layout body -->
    <router-outlet></router-outlet>
  </div>
  <!-- moves to the top of the screen -->
  <div fxLayoutAlign="flex-end" class="go-to-top-fab-wrapper" *ngIf="isShow==true && innerWidth">
    <button mat-mini-fab (click)="gotoTop()" class="go-to-top-fab">
      <mat-icon>arrow_upward</mat-icon>
    </button>
  </div>
  <!-- footer -->
  <app-footer *ngIf="!router.url.includes('careers/auth?')"></app-footer>
</div>